import { CheckCircleFilled, DeleteOutlined } from "@ant-design/icons";
import type {
  WebBlock,
  WebInputChoice,
} from "@p0security/shared/integrations/notifiers/web-requests/types";
import { Button, Flex, Spacing, Spin, Typography } from "@p0security/ui";
import type { FetchOptionsArgs } from "components/Jit/Modal/BlockRenderers";
import { BlocksRenderer } from "components/Jit/Modal/BlockRenderers";
import { FormRow, RowLabel } from "components/common/FormRow";
import {
  PillSelect,
  type PillSelectOption,
} from "components/common/PillSelect";
import type { UseFormReturn } from "react-hook-form";
import { FormProvider } from "react-hook-form";

export const ResourceConfigurator: React.FC<{
  visible: boolean;
  accessTypeOptions: PillSelectOption<string>[];
  accessTypeBlockHidden: boolean;
  selectedAccessType: string | undefined;
  onSelectAccessType: (value: string) => void;
  argBlocks: WebBlock[];
  form: UseFormReturn;
  onFetchOptions: (args: FetchOptionsArgs) => Promise<WebInputChoice[]>;
  watching: Record<string, unknown>;
  dispatching: boolean;
  isComplete: boolean;
  onRemove: () => void;
}> = ({
  visible,
  accessTypeOptions,
  accessTypeBlockHidden,
  selectedAccessType,
  onSelectAccessType,
  argBlocks,
  form,
  onFetchOptions,
  watching,
  dispatching,
  isComplete,
  onRemove,
}) => {
  if (!visible) return null;

  return (
    <Flex align="start" gap={8}>
      <Flex vertical gap={8} flex="1">
        {accessTypeOptions.length > 0 && !accessTypeBlockHidden && (
          <FormRow>
            <RowLabel width={30}>
              Access type
              <Typography.Text type="danger"> *</Typography.Text>
            </RowLabel>
            <PillSelect
              options={accessTypeOptions}
              value={selectedAccessType}
              onChange={onSelectAccessType}
              placeholder="Select an access type"
            />
          </FormRow>
        )}

        {argBlocks.length > 0 && (
          <FormProvider {...form}>
            <Flex vertical gap={8}>
              <BlocksRenderer
                blocks={argBlocks}
                onFetchOptions={onFetchOptions}
                watching={watching}
                variant="compact"
              />
            </Flex>
          </FormProvider>
        )}
      </Flex>
      <Spacing asChild mt={2}>
        <Flex gap={4} align="center">
          {dispatching ? (
            <Spin size="small" />
          ) : (
            isComplete && (
              <CheckCircleFilled className="text-green-500 text-xs" />
            )
          )}
          <Button
            type="text"
            danger
            size="small"
            onClick={onRemove}
            icon={<DeleteOutlined />}
          />
        </Flex>
      </Spacing>
    </Flex>
  );
};
